import classNames from 'classnames';
import { ScommesseTableTitle } from 'components/scommesseTable/scommesseTableTitle';
import { Scommessa as ScommesseTipoEsitiOverThree } from 'components/scommesseTipo/scommesseTipoEsitiOverThree/Scommessa';
import { Scommessa as ScommesseTipoEsitiOverThreeEstesa } from 'components/scommesseTipo/scommesseTipoEsitiOverThreeEstesa/Scommessa';
import { Scommessa as ScommesseTipoEsitiUnderThree } from 'components/scommesseTipo/scommesseTipoEsitiUnderThree/Scommessa';
import { useIsOverTree } from 'features/sport/hooks';
import { useIsAvvenimento } from 'features/virtual/hooks';
import { KeyManagerVirtual } from 'features/virtual/utils/keyManagerVirtual';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { ItemWithTranslation } from 'types/swagger';
import { gtag } from 'utility/functions';
import styles from './VirtualScommesseWrapper.module.scss';
import { VirtualScommesseWrapperInner } from './virtualScommesseWrapperInner';

export type VirtualScommesseWrapperProps = ItemWithTranslation<{ title?: string }> & {
  title?: string;
  titleTrKey?: string;
  isLeague?: boolean;
  hasHeader?: boolean;
  hasEstesa?: boolean;
  scommessaKey: string;
};

interface ItemProps extends VirtualScommesseWrapperProps {
  isOverThree: boolean;
  gtagAction: () => void;
}

const DataRow = (props: ItemProps) => {
  const { isOverThree, hasEstesa } = props;
  const isAvvenimento = useIsAvvenimento();

  const Item = useMemo(() => {
    if (isOverThree) {
      if (hasEstesa) {
        return ScommesseTipoEsitiOverThreeEstesa;
        // fallback: <EsitiOverThreeEstesaSkeleton {...props} />,
      }
      return ScommesseTipoEsitiOverThree;
      // fallback: <EsitiOverThreeSkeleton {...props} />,
    }
    return ScommesseTipoEsitiUnderThree;
    // fallback: <EsitiUnderThreeSkeleton {...props} />,
  }, [isOverThree, hasEstesa]);

  return <Item {...props} hasHeader={isAvvenimento} />;
};

export const VirtualScommesseWrapper = (props: VirtualScommesseWrapperProps) => {
  const { title, titleTrKey, isLeague, scommessaKey } = props;

  const { asPath } = useRouter();
  const section = useMemo(
    () =>
      asPath
        .split('/')
        .filter((x) => x?.length > 0)
        .pop() ?? '',
    [asPath]
  );

  const gtagAction = () => {
    gtag({ section, detail: 'Virtual Bet', event: 'Click su quota' }, true);
  };

  const { tipoScommessaId } = useMemo(() => new KeyManagerVirtual(scommessaKey), [scommessaKey]);
  const isOverThree = useIsOverTree(tipoScommessaId);

  return (
    <VirtualScommesseWrapperInner isLeague={isLeague} className={classNames({ [styles.estesa]: isOverThree })}>
      {title && (
        <ScommesseTableTitle labelDx={title} labelDxTrKey={titleTrKey} className={classNames(styles.mainTitle)} />
      )}
      <DataRow {...props} isOverThree={isOverThree} gtagAction={gtagAction} />
    </VirtualScommesseWrapperInner>
  );
};
